export enum EmailCategory {
  Confirm = 'confirm',
  Cancel = 'cancel',
  Create = 'create',
  Request = 'request',
}

export type EmailTemplateType = RequestEmailTemplate | CancelEmailTemplate | ConfirmEmailTemplate;

export enum ConfirmEmailTemplate {
  ConfirmVt = 'confirmVt',
  ConfirmHt = 'confirmHt',
  ConfirmPhone = 'confirmPhone',
  ConfirmDigital = 'confirmDigital',
  Avu = 'avu',
}
export enum RequestEmailTemplate {
  RequestStatus = 'requestStatus',
  RequestStatusFollowUp = 'requestStatusFollowUp',
  RequestVt = 'requestVt',
  RequestHt = 'requestHt',
  RequestFinal = 'requestFinal',
}
export enum CancelEmailTemplate {
  CandidateCancel = 'candidateCancel',
  Cancel = 'cancel',
}

// TODO-KY-GREEN: move to translations
export const EMAIL_CATEGORY_TRANSLATIONS = {
  [EmailCategory.Cancel]: 'Absage',
  [EmailCategory.Confirm]: 'Terminbestätigung',
  [EmailCategory.Create]: 'Terminanfrage',
  [EmailCategory.Request]: 'Abfrage',
};

export const EMAIL_TEMPLATE_TRANSLATIONS = {
  [CancelEmailTemplate.Cancel]: 'Absage',
  [CancelEmailTemplate.CandidateCancel]: 'Terminabsage',

  [ConfirmEmailTemplate.ConfirmDigital]: 'Digital',
  [ConfirmEmailTemplate.ConfirmHt]: 'HT',
  [ConfirmEmailTemplate.ConfirmPhone]: 'Telefon',
  [ConfirmEmailTemplate.ConfirmVt]: 'VT',
  [ConfirmEmailTemplate.Avu]: 'AVU',

  [RequestEmailTemplate.RequestFinal]: 'Finale Abfrage',
  [RequestEmailTemplate.RequestHt]: 'HT',
  [RequestEmailTemplate.RequestStatus]: 'Statusabfrage',
  [RequestEmailTemplate.RequestStatusFollowUp]: 'Statusabfrage 2',
  [RequestEmailTemplate.RequestVt]: 'VT',
};
